import React, { Fragment, ReactNode } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import cn from 'classnames';
import { userType } from '../roomHelpers';
import { CardMenu } from '../../card/cardMenu';
import { ReactComponent as LikeSvg } from '../../../assets/icons/likeIco.svg';
import styles from './cardLayout.module.scss';
import { globalStore } from '../../../global.store';
import { cardsStore } from '../cards.store';
import { cerebrumStore } from '../../../modules/cerebrum/cerebrum.store';
import cardStyles from '../../card/card.module.scss';

interface CardsWrapperType {
  image: string;
  action: () => void;
  children: ReactNode;
  marker?: ReactNode;
  room: any;
  className?: string;
}

const CardsWrapper = observer(
  ({
    image,
    children,
    action,
    marker = <Fragment />,
    room,
    className,
  }: CardsWrapperType) => {
    const { setEditableRoomData, setPopupContentType } = cardsStore;
    const { likeRoom } = cerebrumStore;
    const { userData, userIsGuest } = globalStore;

    const [searchParams] = useSearchParams();

    const location = useLocation();

    return (
      <div
        className={cn(
          styles.card,
          searchParams.has('listModeActive')
            ? styles.horizontalView
            : styles.verticalView,
          className,
        )}
      >
        <div className={cardStyles.cardActions}>
          <CardMenu
            setPopupToggle={() => setEditableRoomData(room)}
            setPopupContantType={setPopupContentType}
            userType={userType(
              userData.id,
              room?.creator?.id,
              room?.admins,
              location.pathname.includes('copia'),
            )}
            roomId={room?.id}
            roomState={room.status}
            isHomeSpace={room.type === 6}
          />
          {!location.pathname.includes('copia') && (
            <div
              className={cn(cardStyles.cardLikes, {
                [cardStyles.disable]: userIsGuest(),
              })}
              onClick={async () => {
                if (!userIsGuest()) await likeRoom(room.id);
              }}
            >
              <LikeSvg
                className={cn(cardStyles.iconHeart, 'icon-heart', {
                  [cardStyles.liked]: room?.isLiked,
                })}
              />
              <p className={cardStyles.cardLikesAmount}>
                {room?.likesTotalCount}
              </p>
            </div>
          )}
        </div>
        <div className={styles.cardCover} onClick={action}>
          {marker}
          <img
            className={styles.cardImage}
            src={image}
            alt="card"
            loading="lazy"
          />
        </div>
        <div className={styles.cardBody} onClick={action}>
          {children}
        </div>
      </div>
    );
  },
);

export default CardsWrapper;
